













import { Vue, Component, Prop } from 'vue-property-decorator';
@Component({
    components: {}
})
export default class Button extends Vue {
    @Prop({
        type: String,
        required: true
    })
    title!: string;
    @Prop({
        type: String,
        required: true
    })
    command!: string;
    clickSend() {
        this.$emit('ico-click', { command: this.command });
    }
    mounted() {
        console.log('----');
    }
}
